import Link from "next/link";
import SafeEmailText from "@/components/common/SafeEmailText";

type ContactContentItem = {
  id: number;
  title: string;
  action: string;
  text?: string;
  email?: string;
  isEmail?: boolean;
};

const ContactInfo = () => {
  const contactContent: ContactContentItem[] = [
    {
      id: 1,
      title: "Toll Free Customer Care",
      action: `tel:${process.env.NEXT_PUBLIC_ADMIN_CONTACT}`,
      text: process.env.NEXT_PUBLIC_ADMIN_CONTACT,
    },
    {
      id: 2,
      title: "Need live support?",
      action: "/contact",
      isEmail: true,
      email: process.env.NEXT_PUBLIC_ADMIN_EMAIL,
    },
  ];
  return (
    <>
      {contactContent.map((item) => (
        <div className="mt-30" key={item?.id}>
          <div className={"text-14 mt-30"}>{item?.title}</div>
          <Link href={item?.action} className="text-18 fw-500 text-blue-1 mt-5">
            {item?.isEmail ? <SafeEmailText email={item.email} /> : item?.text}
          </Link>
        </div>
      ))}
    </>
  );
};

export default ContactInfo;
